import type { FC } from 'react'
import { CwsA, CwsGrid, CwsGridCol, CwsGridRow, CwsH2, CwsP, CwsSection } from '@components/cws'
import NotFoundIcon from '@components/category/CategoryView/assets/NotFound.svg'
import moduleStyles from '@components/cart/FooterPanel/FooterPanel.module.scss'
import React from 'react'
import { useRouter } from 'next/router'
import { useTranslate } from '@hooks/useTranslation'
import { isGloballyPricelist } from '@utils/pricelist-utils/app-properties'

export const NothingFound: FC = () => {
  const {
    push,
    query: { catalogId },
  } = useRouter()
  const { translate } = useTranslate()

  const mainInfoTranslation: string = isGloballyPricelist()
    ? 'w2.pricelist.not.found.heading'
    : 'error.search.results.nothing'

  return (
    <CwsSection className="cws-my-xl cws-py-l bg-white mx-0 desktop:mx-8">
      <CwsGrid>
        <CwsGridRow noGutterVertical justifyContent="center">
          <CwsGridCol lg="8" col="8" xs="12">
            <div className="flex flex-col items-center justify-center gap-y-lg py-xl">
              <NotFoundIcon />
              <CwsH2 textAlign="center">{translate(mainInfoTranslation)}</CwsH2>
              {isGloballyPricelist() && <CwsP textAlign="center">{translate('w2.pricelist.not.found.info')}</CwsP>}
              <CwsA
                color="buoy-dark"
                className={moduleStyles.withBackArrow}
                hideArrow
                onClick={() => push(`/${catalogId || ''}`)}
              >
                {translate('breadcrumb.back.to.home')}
              </CwsA>
            </div>
          </CwsGridCol>
        </CwsGridRow>
        {/*<CwsGridRow>*/}
        {/*  <div className="w-full h-px mt-lg bg-medium-grey mb-lg" />*/}
        {/*</CwsGridRow>*/}
      </CwsGrid>
    </CwsSection>
  )
}

export default NothingFound
